import React, { Component } from 'react'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import moment from 'moment'
import MacroGraph from '../components/average-graph/macro-graph'
import styled from 'styled-components'
import { Line } from 'rc-progress'

const ComplianceDialog = styled(Dialog)`
  .MuiDialog-paper {
    background: #08091f;
    color: #FFF;
  }

  .avn-modal-action {
    color: #FFF;

    &:hover {
      background: #1d2345;
    }

    &:focus-visible {
      outline: 2px solid #FFF;
      outline-offset: 2px;
    }
  }
`;

const CaloriesSummary = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin: 8px auto 16px;
  width: 120px;

  label {
    color: #ffffffc7;
    font-family: 'DM Sans', sans-serif;
    font-size: 0.875rem;
    font-weight: bold;
    margin: 4px 0;
    white-space: nowrap;
  }
`;

class ComplianceDetailsModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
    }
  }

  componentDidMount() {
    if (this.props.relatedWeighInDetails !== null && this.props.relatedWeighInDetails.level === 0) {
      this.props.getMacroData(this.props.relatedWeighInDateString)
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.complianceDetailsDate !== prevProps.complianceDetailsDate && this.props.relatedWeighInDetails !== null && this.props.relatedWeighInDetails.level === 0) {
      this.props.getMacroData(this.props.relatedWeighInDateString)
    }
  }

  handleClose = () => {
    this.props.handleClose();
  }

  render() {
    const result = this.props.relatedWeighInDetails?.level === 2
      ? this.props.relatedWeighInDetails.result : null;
    const avgCalories = result
      ? Math.round(4 * (result.avgProtein + result.avgCarbs) + 9 * result.avgFat) : 0;
    const avgTargetCalories = result
      ? 4 * (result.avgTargetProtein + result.avgTargetCarbs) + 9 * result.avgTargetFat : 0;

    return (
      <ComplianceDialog className='weigh-in-dialog' open={this.props.open} onClose={this.handleClose}>
        <DialogContent className='avn-modal-content-container'>
          <div className='avn-modal-header-container'>
            {this.props.relatedWeighInDetails === null ? (
              <div>
                <h4>{moment.utc(this.props.complianceDetailsDate).format('MMM D, YYYY')}</h4>
                <p>Average tracked macros are not available for this check-in.</p>
              </div>
            ) : (this.props.relatedWeighInDetails.level !== 2 ? (
              <div>loading...</div>
            ) : (
              <div>
                <h4 style={{fontSize: '1.5rem', margin: '16px 0px'}}>{moment.utc(this.props.complianceDetailsDate).format('MMM D, YYYY')}</h4>
                <MacroGraph
                  proteinConsumed={Math.round(this.props.relatedWeighInDetails.result.avgProtein)}
                  carbsConsumed={Math.round(this.props.relatedWeighInDetails.result.avgCarbs)}
                  fatConsumed={Math.round(this.props.relatedWeighInDetails.result.avgFat)}
                  proteinTarget={Math.round(this.props.relatedWeighInDetails.result.avgTargetProtein)}
                  carbsTarget={Math.round(this.props.relatedWeighInDetails.result.avgTargetCarbs)}
                  fatTarget={Math.round(this.props.relatedWeighInDetails.result.avgTargetFat)}
                  vacationMode={this.props.vacationMode}
                  showConsumedMacros
                  showUnderRange
                />
                <CaloriesSummary>
                  <label>AVG. CALORIES</label>
                  <Line
                    percent={avgTargetCalories > 0 ? (avgCalories / avgTargetCalories) * 100 : 0}
                    strokeWidth="9"
                    strokeLinecap="round"
                    strokeColor="#31bfff"
                    trailWidth="9"
                    trailColor="#1d2345"
                  />
                  <label style={{ color: '#FFF' }}>
                    {avgCalories} / {Math.round(avgTargetCalories)} EATEN
                  </label>
                </CaloriesSummary>
              </div>
            ))}
          </div>
        </DialogContent>
        <DialogActions className="avn-modal-actions-container">
          <button className='avn-modal-action' onClick={this.handleClose} style={{marginTop: 0}}>Close</button>
        </DialogActions>
      </ComplianceDialog>
    )
  }
}

export default ComplianceDetailsModal
